export default __webpack_public_path__ + "static/media/facebook.064168cc.svg";